<template>
  <div class="tw-max-w-screen-lg tw-mx-auto tw-px-4 lg:tw-px-0">
    <div v-if="data.solicitations && data.solicitations.length > 0">
      <h2 class="tw-mb-4">Open & Pending Solicitations</h2>

      <!-- Loop through solicitations and render each as a separate component -->
      <solicitation-item
        v-for="(solicitation, index) in data.solicitations"
        :key="solicitation.id"
        :solicitation="solicitation"
        :initial-open="index === 0 || index === 1"
      />
    </div>
    <div v-else class="tw-max-w-[711px] tw-mx-auto">
      <h2 class="tw-mb-4">Open & Pending Solicitations</h2>
      <p
        class="tw-text-base tw-p-6 tw-rounded-md tw-bg-slate-100 tw-border tw-border-slate-300 tw-border-solid"
      >
        No open or pending solicitations at this time. Please check back
        frequently for status updates.
      </p>
    </div>
  </div>
</template>

<script>
import SolicitationItem from './SolicitationItem.vue'

export default {
  name: 'SolicitationsComponent',
  components: {
    SolicitationItem,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({ solicitations: [] }),
    },
  },
  mounted() {
    this.$nextTick(() => {
      // Handle solicitation interest functionality
      const interestButtons = document.querySelectorAll('.interest-button')

      interestButtons.forEach((button) => {
        button.addEventListener('click', function () {
          const solicitation = this.getAttribute('data-solicitation')
          if (solicitation) {
            setTimeout(() => {
              window.open(
                `/solicitation-form/?solicitation=${encodeURIComponent(
                  solicitation,
                )}`,
                '_blank',
              )
            }, 300)
          }
        })
      })
    })
  },
}
</script>
